import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SurveyTemplate, SurveyQuestion, SurveyChoice } from '../../models/survey-template-document';
import { SurveyResponse } from '../../models/survey-response-document';
import { FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ResourceService } from '../../resource.service';
import * as _ from 'lodash';

@Component({
  standalone: false,
  selector: 'app-survey-section',
  templateUrl: './survey-section.component.html',
  styleUrls: ['./survey-section.component.scss']
})
export class SurveySectionComponent implements OnInit {
  @Input() surveyTemplate: SurveyTemplate;
  @Input() surveyChoices: SurveyChoice[] = [];

  surveyQuestions: SurveyQuestion[] = [];
  form: FormGroup;
  areAllQuestionsAnswered = false;

  @Output() categoryCompleted: EventEmitter<SurveyResponse> = new EventEmitter<SurveyResponse>();

  constructor(private resourceService: ResourceService) { }

  ngOnInit() {
    this.form = this.buildForm();
  }

  // build form using question order and id for form controls
  buildForm() {
    const formGroup: FormGroup = new FormGroup({});
    this.surveyQuestions = this.surveyTemplate.questions.sort((a, b) => a.order < b.order ? -1 : 1);
    _.each(this.surveyQuestions, (question) => {
      const formId = question.id;
      const formControl = new FormControl();
      formGroup.addControl(formId, formControl);
    });
    return formGroup;
  }

  movePrevious(): void {

  }

  public moveNext(): void {
    const surveyResponse = this.resourceService.convertToSurveyResponse(this.form, this.surveyTemplate, this.surveyChoices);
    if (this.validateSurveyResponse(surveyResponse)) {
      this.categoryCompleted.emit(surveyResponse);
    }
  }

  public validateAnswers(): void {
    const surveyResponse = this.resourceService.convertToSurveyResponse(this.form, this.surveyTemplate, this.surveyChoices);
    this.areAllQuestionsAnswered = this.validateSurveyResponse(surveyResponse);
    if (this.areAllQuestionsAnswered) {
      this.categoryCompleted.emit(surveyResponse);
    }
  }

  private validateSurveyResponse(surveyResponse: SurveyResponse): boolean {
    if (!surveyResponse || !surveyResponse.answers || surveyResponse.answers.length !== this.surveyQuestions.length) {
      return false;
    }
    let isValid = true;
    for (let i = 0; i < surveyResponse.answers.length; ++i) {
      const answer = surveyResponse.answers[i];
      if (!answer || answer.choice_id === null || answer.choice_id === undefined) {
        isValid = false;
        break;
      }
    }
    return isValid;
  }

}
